import React from 'react'

import { useStep2Props } from './types'
import useStep2 from './hooks/useStep2'
import { wrap } from '../../../utils/globalUtils'
import Step2View from './views/Step2View'

const Step2: React.FC<useStep2Props> = wrap(Step2View, useStep2)
export default Step2
